import { getQSApiDomain, transformQuadlinkSuccessCallback } from '../../helpers';
/**
 * Transform Quadlink
 * @param {object} options - Optional config parameter
 */
export function transformQuadlink(options = {}) {
	let response = {};
	const request = new XMLHttpRequest(),
		apiUrl = getQSApiDomain() + window.modForm.opts.trafficDetailsApi;

	request.open('POST', apiUrl);
	request.setRequestHeader('Content-Type', 'application/json');
	request.send(JSON.stringify(window.modForm.opts.quadLinkData));
	request.addEventListener('load', async function() {
		if (this.response) {
			response = { ...response, ...JSON.parse(this.response) };
			if (this.readyState === 4 && this.status === 200) {
				transformQuadlinkSuccessCallback(response, options);
			}
		}
	});
	request.addEventListener('error', function() {
		console.error('Something went wrong');
	});
}
